import React from "react";
import { Paper } from '@mui/material'
import Carousel from 'react-material-ui-carousel'
import '../CategoriesImages/CategoriesImage.css'
import useMediaQuery from '@mui/material/useMediaQuery';

const carouselStyle = {
    backgroundColor: "transparent", 
    boxShadow: "none",
    marginBottom: "20px"
}

function CategoriesImageUI({
    details
}) {
    return (
        <div>
            
            <Carousel indicatorContainerProps={{}} interval={1500} autoPlay={true} style={carouselStyle}>
                {
                    details.map((item, i) => <Item key={i} item={item} />)
                }
            </Carousel>
        </div>

    )
}

function Item(props) {
    const matches = useMediaQuery('(min-width:600px)');
    return (
        <Paper sx={{
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: 'none'
        }}>
            {
                matches && (
                    <img src={props.item.image} alt={props.item.name}
                        style={{ 
                            width: "100%", 
                            height: "350px",
                            objectFit: "contain",
                            padding: "10px"
                        }} loading="lazy" />
                )
            }
            {
                !matches && (
                    <img src={props.item.image} alt={props.item.name}
                        style={{ 
                            width: "100%", 
                            height: "220px",
                            objectFit: "contain",
                            padding: "10px"
                        }} loading="lazy" />
                )
            
            }
        </Paper>
    )
}

export { CategoriesImageUI }